/**
 * An array of objects representing checkbox options for packet status.
 */
export const checkboxStatus = [
    { value: 'viewall', label: 'View All' },
    // { value: 'uploading', label: 'Uploading' },
    { value: 'scanning', label: 'Scanning' },
    // { value: 'categorising', label: 'Categorising' },
    // { value: 'virusFound', label: 'Virus Found' },
    { value: 'highlighted', label: 'Highlighted' },
    { value: 'noDocumentsFound', label: 'No Document Found' },
    { value: 'duplicationFound', label: 'Duplication Found' },
    { value: 'categorisationFailed', label: 'Categorisation failed' },
    // { value: 'categorisationCompleted', label: 'Categorisation Completed' },
    { value: 'verifying', label: 'Processing QA' },
    { value: 'reviewRequired', label: 'Review required' },
    // { value: 'generatingReport', label: 'Generating Report' },
    { value: 'verified', label: 'Verified' },
    // { value: 'sentForRework', label: 'Sent for rework' },
    { value: 'escalated', label: 'Escalated' },
    { value: 'notExpected', label: 'Not Expected' },
    // { value: 'attachedWithOriginalPacket', label: 'Original Attachment' },
    // { value: 'fullyDuplicate', label: 'Fully Duplication' },
    // { value: 'partiallyDuplicate', label: 'Partial Duplication' },
    // { value: 'duplicateWithAllNewDocs', label: 'Duplicate - New docs' },
    { value: 'purged', label: 'Purged' },
    { value: 'validationFailed', label: 'Validation Failed' },
    // { value: 'encrypted', label: 'Encrypted' },
    // { value: 'processingVerification', label: 'Processing verification' },
    { value: 'documentMissing', label: 'Document Missing' },
    { value: 'completed', label: 'Completed' },
    { value: 'openByAnotherOP', label: 'Open by another member' },
];
